export default function () {
  if (!window || !window.process || !window.process.versions['electron']) {
    return false
  }

  return true
}
